import queryClient from '@/lib/queryClient'
import { buildAdminQueryRoot, type AdminQueryKey } from '@/lib/organization-scoping'

type PricingInvalidationRoot = 'priceAdjustments' | 'products' | 'collections' | 'categories'

const pricingInvalidationRoots = ({
  organizationId,
}: {
  organizationId: number | string
}): Record<PricingInvalidationRoot, AdminQueryKey> => ({
  priceAdjustments: [buildAdminQueryRoot({ entity: 'price-adjustment' }, { organizationId })],
  products: [buildAdminQueryRoot({ entity: 'product' }, { organizationId })],
  collections: [buildAdminQueryRoot({ entity: 'collection' }, { organizationId })],
  categories: [buildAdminQueryRoot({ entity: 'category' }, { organizationId })],
})

export function invalidatePricingMutationDependencies(
  organizationId: number | string,
  { includeCategories = false }: { includeCategories?: boolean } = {}
) {
  const roots = pricingInvalidationRoots({ organizationId })

  return Promise.all(
    [
      roots.priceAdjustments,
      roots.products,
      roots.collections,
      includeCategories ? roots.categories : null,
    ]
      .filter((queryKey) => queryKey !== null)
      .map((queryKey) => queryClient.invalidateQueries({ queryKey }))
  )
}
